'use client';
import { Accordion, AccordionProps } from '@mui/material';
import { trackEvent } from '../../../../utils/trackEvent';
import getRichTextSummary from '../../../RichText/getRichTextSummary';
import { RichTextContent } from '../../../RichText';

type Props = AccordionProps & {
  question: RichTextContent;
};

const FaqAccordion = ({ question, ...props }: Props) => {
  return (
    <Accordion
      sx={{
        '&.Mui-expanded::before': { opacity: 1 },
      }}
      disableGutters
      elevation={0}
      variant={'elevation'}
      slots={{
        heading: 'h3',
      }}
      onChange={(e, expanded) =>
        expanded &&
        trackEvent('select_content', {
          content_type: 'faq',
          item_id: getRichTextSummary(question),
        })
      }
      {...props}
    />
  );
};

export default FaqAccordion;
